import {ROOM_MESSAGE} from '../constants/roomMessages';

import {BobTVUser} from '../components/bobtv-neo/BobTVUser/index';

import bbcodeRender from '../3rdparty/bbcode/index';

function stripHTML(OriginalString) {
    return OriginalString.replace(/(<([^>]+)>)/ig, "");
}

const roomMessagesMiddleware = (store) => (next) => (action) => {
    if (action.type == ROOM_MESSAGE) {
        let {currentUser, users} = store.getState();

        let {uid, nick, ufrag, ...message} = action.message;
        let user = users.get({ufrag});

        if (!user) {
            user = new BobTVUser({id: uid, uid: uid, nick: nick, ufrag: ufrag, online: false, stub: true});
        }

        let mentionCB = function(userNick) { this.mentions.push(userNick) };
        let mentionsObj = {mentions: []};
        mentionCB = mentionCB.bind(mentionsObj);

        let messageText = stripHTML(message.message);
        let messageTextRendered = messageText ? bbcodeRender(messageText, {currentNick: currentUser.nick, mentionCB}).replace(/\n/g, '<br/>') : '';
        let mentionUsers = mentionsObj.mentions.map((userNick) => users.get({nick: userNick}) || new BobTVUser({nick: userNick, online: false, stub: true}));

        next({
            ...action,
            message: {...message, rendered: messageTextRendered},
            roomid: message.roomid,
            user,
            mentionUsers
        });
    } else {
        next(action)
    }
};

export default roomMessagesMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/roomMessages.js